// Constants
import CONST_USER_PROFILE from 'constants/userProfile';

// Types
import { UserDocumentsInterface } from 'store/ducks/users/types';

// Masks
import { maskCPF, maskRG, maskRG2 } from './maskers';

/**
 * @param documents UserDocumentsInterface[]
 * @description Return a string formatted as RG or CPF
 */
export function findDocumentByType(
  documents?: UserDocumentsInterface[],
): string {
  if (!Array.isArray(documents)) return '';
  const [DOCUMENT_CPF, DOCUMENT_RG] = CONST_USER_PROFILE.RESOURCES_TYPE;
  const RG_LENGTH = 9;
  let document = '';

  if (Array.isArray(documents)) {
    const foundCPF = documents.find((doc) => doc.type === DOCUMENT_CPF.TYPE);
    const foundRG = documents.find((doc) => doc.type === DOCUMENT_RG.TYPE);

    // prettier-ignore
    if (foundCPF) document = maskCPF(foundCPF.document);
    else if (foundRG) {
      if (foundRG.document.replace(/\D/g, '')?.length === RG_LENGTH) {
        document = maskRG(foundRG.document);
      } else document = maskRG2(foundRG.document);
    } else {
      document =
        documents.find((doc) => doc.type !== DOCUMENT_CPF.TYPE)?.document ||
        'Sem documento';
    }
  }
  return document;
}

/**
 * @param documents UserDocumentsInterface[]
 * @description Return the type of document (RG or CPF)
 */
export function findDocumentType(documents?: UserDocumentsInterface[]): string {
  if (!Array.isArray(documents)) return '--';
  const [DOCUMENT_CPF, DOCUMENT_RG] = CONST_USER_PROFILE.RESOURCES_TYPE;
  let document = '';

  if (Array.isArray(documents)) {
    const foundCPF = documents.find((doc) => doc.type === DOCUMENT_CPF.TYPE);
    const foundRG = documents.find((doc) => doc.type === DOCUMENT_RG.TYPE);

    // prettier-ignore
    if (foundCPF) document = DOCUMENT_CPF.VALUE;
    else if (foundRG) document = DOCUMENT_RG.VALUE;
    else {
      document = 'Documento';
    }
  }

  return document;
}

/**
 * @param type number (0, 1, ...)
 * @param document string (12345678901)
 * @description Return a string formatted as RG or CPF
 */
export function formatDocument(type: number, document: string) {
  const RG_LENGTH = 9;
  let documentWithMask = '';

  const doc = CONST_USER_PROFILE.DOCUMENT_TYPE.find(({ TYPE }) => TYPE === type)
    ?.VALUE;

  switch (doc) {
    case 'CPF':
      documentWithMask = maskCPF(document);
      break;
    case 'RG':
      if (document.replace(/\D/g, '')?.length === RG_LENGTH) {
        documentWithMask = maskRG(document);
      } else documentWithMask = maskRG2(document);
      break;
    default:
      documentWithMask = document;
  }

  return documentWithMask;
}

export function prettieCnpj(cnpj: string) {
  return cnpj.replace(
    /^([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})(\d{2})/,
    '$1.$2.$3 / $4-$5',
  );
}

export function clearDocument(document: string) {
  return document
    .replaceAll('.', '')
    .replaceAll('-', '')
    .replaceAll('/', '')
    .trim()
    .toUpperCase();
}
